:host {
  display: inline-block;
  --size: var(--sportsline-over-under-image-size, 3.75rem);
}

svg {
  width: 100%;
  height: 100%;
  display: block;
}

svg * {
  fill: var(--Utility-Icon-Primary, currentColor);
}

.sportsline-over-under-image {
  float: left;
  width: var(--size);
  height: var(--size);
}

.sportsline-over-under-image--under {
  transform: rotate(180deg);
}

.sportsline-over-under-image--over {
  transform: rotate(0deg);
}

.sportsline-over-under-image--small {
  width: var(--sportsline-over-under-image-size-small, 1.25rem);
  height: var(--sportsline-over-under-image-size-small, 1.25rem);
}

.sportsline-over-under-image--medium {
  width: var(--sportsline-over-under-image-size-medium, 2.625rem);
  height: var(--sportsline-over-under-image-size-medium, 2.625rem);
}

.sportsline-over-under-image--large {
  width: var(--sportsline-over-under-image-size-large, 3rem);
  height: var(--sportsline-over-under-image-size, 3rem);
}

.sportsline-over-under-image--extra-large {
  width: var(--sportsline-over-under-image-size-extra-large, 3.75rem);
  height: var(--sportsline-over-under-image-size-extra-large, 3.75rem);
}
